module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-duedate-month-6-75f7f9b99393ab3b614b1c6f26e8351b.svg";